import { render, staticRenderFns } from "./StatsCampaignsChart.vue?vue&type=template&id=b8e2d3e2&scoped=true&"
import script from "./StatsCampaignsChart.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e2d3e2",
  null
  
)

export default component.exports